import { Box } from '@mui/material';
import React, { createContext, FC, useCallback, useState } from 'react';

interface ActivityDetectorProviderProps {
  isUserActive: boolean;
}

export const ActivityDetectorContext = createContext<ActivityDetectorProviderProps>({
  isUserActive: false,
});

export const ActivityDetectorProvider: FC<ActivityDetectorProviderProps> = ({ children }) => {
  const [isUserActive, setIsUserActive] = useState(false);

  const onClickHandler = useCallback(() => {
    setIsUserActive((prevState: boolean) => {
      if (!prevState) {
        return true;
      }

      return prevState;
    });
  }, []);

  return (
    <ActivityDetectorContext.Provider value={{ isUserActive }}>
      <Box height="100vh" onClick={onClickHandler}>
        {children}
      </Box>
    </ActivityDetectorContext.Provider>
  );
};
